import React, { useState, useEffect } from "react";
import BarGraph from "./BarGraph";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { Spinner } from "react-bootstrap";
import swal from "sweetalert";
export default function AllAnalytics() {
  const [type, setType] = useState("ToDay");
  const [spinner, setSpinner] = useState(false);
  const [analyticData, setAnalyticData] = useState({
    totalOrderAmount: 0,
    totalOrderCount: 0,
    cancelledOrderAmount: 0,
    cancelledOrderCount: 0,
  });
  const [fiveYearsData, setFiveYearsData] = useState([]);
  const [months, setMonths] = useState("");
  const [lastYear, setLastYear] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [tillDate, setTillDate] = useState("");
  const currentDate = new Date().toISOString().split("T")[0];

  const typeArray = [
    "ToDay",
    "Yesterday",
    "Weekly",
    "This Month",
    "Last Month",
    "Monthly",
    "Yearly",
    "Custom Dates",
    "Last Years",
  ];
  const monthArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  function getMonthAnalyticsData(month) {
    setSpinner(true);
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    axios
      .get(
        `${Baseurl.baseurl}/order/get-all-monthly-analytic/${monthArray.indexOf(
          month
        )}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData({
            totalOrderAmount: 0,
            totalOrderCount: 0,
            cancelledOrderAmount: 0,
            cancelledOrderCount: 0,
          });
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getDailyAnalyticData() {
    setSpinner(true);
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let date = currentDate.getDate();
    let month = currentDate.getMonth();
    axios
      .get(
        `${Baseurl.baseurl}/order/get-all-daily-analytic/${date}/${month}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData({
            totalOrderAmount: 0,
            totalOrderCount: 0,
            cancelledOrderAmount: 0,
            cancelledOrderCount: 0,
          });
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getYearlyAnalyticData(sub, year) {
    setSpinner(true);
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    axios
      .get(
        `${Baseurl.baseurl}/order/get-all-yearly-analytic/${
          sub === "this" ? currentYear : year
        }`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData({
            totalOrderAmount: 0,
            totalOrderCount: 0,
            cancelledOrderAmount: 0,
            cancelledOrderCount: 0,
          });
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getWeeklyAnalyticData() {
    setSpinner(true);
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let date = currentDate.getDate();
    let month = currentDate.getMonth();
    axios
      .get(
        `${Baseurl.baseurl}/order/get-all-weekly-analytic/${date}/${month}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData({
            totalOrderAmount: 0,
            totalOrderCount: 0,
            cancelledOrderAmount: 0,
            cancelledOrderCount: 0,
          });
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getCustomDateAnalytics(val) {
    setSpinner(true);
    axios
      .get(
        `${Baseurl.baseurl}/order/get-all-custom-analytic/${
          startDate.split("-")[2]
        }/${startDate.split("-")[1] - 1}/${startDate.split("-")[0]}/${
          val.split("-")[2]
        }/${val.split("-")[1] - 1}/${val.split("-")[0]}`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData({
            totalOrderAmount: 0,
            totalOrderCount: 0,
            cancelledOrderAmount: 0,
            cancelledOrderCount: 0,
          });
        }
      })
      .catch((err) => {});
  }
  useEffect(() => {
    getDailyAnalyticData();
  }, []);
  function getYesterdayAnalyticData() {
    setSpinner(true);
    let currentDate = new Date();
    let yesterdayDate = new Date(currentDate);
    yesterdayDate.setDate(currentDate.getDate() - 1);
    let currentYear = yesterdayDate.getFullYear();
    let date = yesterdayDate.getDate();
    let month = yesterdayDate.getMonth();
    axios
      .get(
        `${Baseurl.baseurl}/order/get-all-daily-analytic/${date}/${month}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData({
            totalOrderAmount: 0,
            totalOrderCount: 0,
            cancelledOrderAmount: 0,
            cancelledOrderCount: 0,
          });
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getLastMonthAnalyticData() {
    setSpinner(true);
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let month = currentDate.getMonth();
    axios
      .get(
        `${Baseurl.baseurl}/order/get-all-monthly-analytic/${
          month - 1
        }/${currentYear}`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData({
            totalOrderAmount: 0,
            totalOrderCount: 0,
            cancelledOrderAmount: 0,
            cancelledOrderCount: 0,
          });
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  function getThisMonthAnalyticData() {
    setSpinner(true);
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let month = currentDate.getMonth();
    axios
      .get(
        `${Baseurl.baseurl}/order/get-all-monthly-analytic/${month}/${currentYear}`
      )
      .then((res) => {
        setSpinner(false);
        if (res.data.status) {
          setAnalyticData(res.data);
        } else {
          setAnalyticData({
            totalOrderAmount: 0,
            totalOrderCount: 0,
            cancelledOrderAmount: 0,
            cancelledOrderCount: 0,
          });
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  return (
    <div>
      <div className="row mb-5">
        <div className="col-sm-3">
          <label>Select Type</label>
          <select
            multiple={false}
            style={{
              border: "1px solid",
              borderColor: "#e6e6e6",
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
            }}
            id="val-skill"
            name="val-skill"
            value={type}
            onChange={(event) => {
              setAnalyticData({
                totalOrderAmount: 0,
                totalOrderCount: 0,
                cancelledOrderAmount: 0,
                cancelledOrderCount: 0,
              });
              setType(event.target.value);
              if (event.target.value === "ToDay") {
                getDailyAnalyticData();
              } else if (event.target.value === "Yesterday") {
                getYesterdayAnalyticData();
              } else if (event.target.value === "Last Month") {
                getLastMonthAnalyticData();
              } else if (event.target.value === "This Month") {
                getThisMonthAnalyticData();
              } else if (event.target.value === "Yearly") {
                getYearlyAnalyticData("this");
              } else if (event.target.value === "Weekly") {
                getWeeklyAnalyticData();
              } else if (event.target.value === "Last Years") {
                let currentDate = new Date();
                let currentYear = currentDate.getFullYear();
                let lastFiveYears = [];
                for (let i = 1; i <= 5; i++) {
                  lastFiveYears.push(currentYear - i);
                }
                setFiveYearsData(lastFiveYears);
                getYearlyAnalyticData("last", lastFiveYears[0]);
              } else if (event.target.value === "Monthly") {
                getMonthAnalyticsData("January");
              }
            }}
          >
            {typeArray.map((val) => {
              return (
                <option style={{ fontSize: "14px" }} value={val}>
                  {val}
                </option>
              );
            })}
          </select>
        </div>
        {type === "Monthly" && (
          <div className="col-sm-3">
            <label>Select Month</label>
            <select
              multiple={false}
              style={{
                border: "1px solid",
                borderColor: "#e6e6e6",
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
              }}
              id="val-skill"
              name="val-skill"
              value={months}
              onChange={(event) => {
                setMonths(event.target.value);
                getMonthAnalyticsData(event.target.value);
              }}
            >
              {monthArray.map((val) => {
                return (
                  <option style={{ fontSize: "14px" }} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {type === "Last Years" && (
          <div className="col-sm-3">
            <label>Select Year</label>
            <select
              multiple={false}
              style={{
                border: "1px solid",
                borderColor: "#e6e6e6",
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
              }}
              id="val-skill"
              name="val-skill"
              value={lastYear}
              onChange={(event) => {
                setLastYear(event.target.value);
                getYearlyAnalyticData("last", event.target.value);
              }}
            >
              {fiveYearsData.map((val) => {
                return (
                  <option style={{ fontSize: "14px" }} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
          </div>
        )}
        {type === "Custom Dates" && (
          <div className="col-sm-3">
            <label>Start Date</label>
            <input
              type="date"
              style={{
                border: "1px solid",
                borderColor: "#e6e6e6",
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
              }}
              id="val-username"
              name="val-username"
              value={startDate}
              max={currentDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                let currentDate = new Date(e.target.value);
                currentDate.setDate(currentDate.getDate());
                let formattedCurrentDate = currentDate
                  .toISOString()
                  .split("T")[0];
                setTillDate(formattedCurrentDate);
              }}
            />
          </div>
        )}
        {type === "Custom Dates" && startDate && (
          <div className="col-sm-3">
            <label>End Date</label>
            <input
              type="date"
              style={{
                border: "1px solid",
                borderColor: "#e6e6e6",
                width: "100%",
                padding: "8px",
                borderRadius: "4px",
              }}
              id="val-username"
              name="val-username"
              min={tillDate}
              value={endDate}
              max={currentDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                getCustomDateAnalytics(e.target.value);
              }}
            />
          </div>
        )}
      </div>
      {spinner ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <div className="row">
            <div className="col-sm-4">
              <div
                className="card"
                style={{
                  borderRadius: "4px",
                  height: "100px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label className="text-sm">Net Orders Count</label>
                <h4 style={{ color: "black", fontWeight: "600" }}>
                  {analyticData.totalOrderCount -
                    analyticData.cancelledOrderCount}
                </h4>
              </div>
            </div>
            <div className="col-sm-4">
              <div
                className="card"
                style={{
                  borderRadius: "4px",
                  height: "100px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label className="text-sm">Cancelled Orders Count</label>
                <h4 style={{ color: "black", fontWeight: "600" }}>
                  {analyticData.cancelledOrderCount}
                </h4>
              </div>
            </div>
            <div className="col-sm-4">
              <div
                className="card"
                style={{
                  borderRadius: "4px",
                  height: "100px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label className="text-sm">Gross Orders Count</label>
                <h4 style={{ color: "black", fontWeight: "600" }}>
                  {analyticData.totalOrderCount}
                </h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div
                className="card"
                style={{
                  borderRadius: "4px",
                  height: "100px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label className="text-sm">Net Orders Amount</label>
                <h4 style={{ color: "black", fontWeight: "600" }}>
                ₹ {(
                    analyticData.totalOrderAmount -
                    analyticData.cancelledOrderAmount
                  )?.toLocaleString("en-IN")}
                </h4>
              </div>
            </div>
            <div className="col-sm-4">
              <div
                className="card"
                style={{
                  borderRadius: "4px",
                  height: "100px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label className="text-sm">Cancelled Order Amount</label>
                <h4 style={{ color: "black", fontWeight: "600" }}>
                ₹ {analyticData.cancelledOrderAmount?.toLocaleString("en-IN")}
                </h4>
              </div>
            </div>
            <div className="col-sm-4">
              <div
                className="card"
                style={{
                  borderRadius: "4px",
                  height: "100px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label className="text-sm">Gross Orders Amount</label>
                <h4 style={{ color: "black", fontWeight: "600" }}>
                ₹  {analyticData.totalOrderAmount?.toLocaleString("en-IN")}
                </h4>
              </div>
            </div>
          </div>

          {/* {analyticData.length !== 0 &&type!=="Custom Dates"&& (
         <div
         className="card row"
         style={{
           borderRadius: "4px",
           height: "300px",
         }}
       >
         <div className="col-sm-6 mt-4">
         <BarGraph data={analyticData.chartDetails} from={"All"} wise={"amount"} />
         </div>
         <div className="col-sm-6 mt-4">
         <BarGraph data={analyticData.chartDetails} from={"All"} wise={"order"} />
         </div>
        
       </div>
      )} */}
        </>
      )}
    </div>
  );
}
